import {useState } from "react";


const useCheckFullScreenMode = () => {

  const [fullScreenModalOpen, setFullScreenModalOpen] = useState(false);

    const handleFullScreenChange = () => {
        if (!document.fullscreenElement) {
          setFullScreenModalOpen(true); 
        }
        else{
          setFullScreenModalOpen(false);
        }
      };
  
      document.addEventListener('fullscreenchange', handleFullScreenChange);
   
      const setFullScreen = (enable) => {
        if (enable) {
          document.documentElement.requestFullscreen().catch(err => {
            console.error(`Error attempting to enable full-screen mode: ${err.message} (${err.name})`);
          });
        } else {
          if (document.fullscreenElement) {
            document.exitFullscreen().catch(err => {
              console.error(`Error attempting to exit full-screen mode: ${err.message} (${err.name})`);
            });
          }
        }
      };
    
  return {
    handleFullScreenChange,
    setFullScreen,
    fullScreenModalOpen,
  }
};

export default useCheckFullScreenMode;
